import { openPage as openPage$1 } from "@tencent/iwan-biz-helper";
import axios from "axios";
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s, _e, _x, _r, _arr = [], _n = true, _d = false;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i)
          return;
        _n = false;
      } else
        for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = true)
          ;
    } catch (err) {
      _d = true, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r))
          return;
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
var regeneratorRuntime$1 = { exports: {} };
var _typeof = { exports: {} };
(function(module) {
  function _typeof2(obj) {
    "@babel/helpers - typeof";
    return module.exports = _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
      return typeof obj2;
    } : function(obj2) {
      return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof2(obj);
  }
  module.exports = _typeof2, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(_typeof);
(function(module) {
  var _typeof$12 = _typeof.exports["default"];
  function _regeneratorRuntime() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    module.exports = _regeneratorRuntime = function _regeneratorRuntime2() {
      return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
      obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function define2(obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
      return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function(method) {
        define(prototype, method, function(arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg, value = result.value;
          return value && "object" == _typeof$12(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value2) {
            invoke("next", value2, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function(unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function(error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function value(method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function(resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self, context) {
      var state = "suspendedStart";
      return function(method, arg) {
        if ("executing" === state)
          throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method)
            throw arg;
          return doneResult();
        }
        for (context.method = method, context.arg = arg; ; ) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel)
                continue;
              return delegateResult;
            }
          }
          if ("next" === context.method)
            context.sent = context._sent = context.arg;
          else if ("throw" === context.method) {
            if ("suspendedStart" === state)
              throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else
            "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
              continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method, method = delegate.iterator[methodName];
      if (void 0 === method)
        return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = void 0, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type)
        return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = void 0), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod)
          return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next)
          return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1, next = function next2() {
            for (; ++i < iterable.length; )
              if (hasOwn.call(iterable, i))
                return next2.value = iterable[i], next2.done = false, next2;
            return next2.value = void 0, next2.done = true, next2;
          };
          return next.next = next;
        }
      }
      return {
        next: doneResult
      };
    }
    function doneResult() {
      return {
        value: void 0,
        done: true
      };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
      return this;
    }), define(Gp, "toString", function() {
      return "[object Generator]";
    }), exports.keys = function(val) {
      var object = Object(val), keys = [];
      for (var key in object)
        keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length; ) {
          var key2 = keys.pop();
          if (key2 in object)
            return next.value = key2, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = false, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
          for (var name in this)
            "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = void 0);
      },
      stop: function stop() {
        this.done = true;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type)
          throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done)
          throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = void 0), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i], record = entry.completion;
          if ("root" === entry.tryLoc)
            return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc)
                return handle(entry.catchLoc, true);
              if (this.prev < entry.finallyLoc)
                return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc)
                return handle(entry.catchLoc, true);
            } else {
              if (!hasFinally)
                throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc)
                return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if ("throw" === record.type)
          throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc)
            return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName,
          nextLoc
        }, "next" === this.method && (this.arg = void 0), ContinueSentinel;
      }
    }, exports;
  }
  module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
})(regeneratorRuntime$1);
var runtime = regeneratorRuntime$1.exports();
var regenerator = runtime;
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if ((typeof globalThis === "undefined" ? "undefined" : _typeof$1(globalThis)) === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
var AppType = /* @__PURE__ */ function(AppType2) {
  AppType2[AppType2["game"] = 1] = "game";
  AppType2[AppType2["app"] = 2] = "app";
  return AppType2;
}(AppType || {});
var AuthType = /* @__PURE__ */ function(AuthType2) {
  AuthType2["gameBehaviourData"] = "gameBehaviourData";
  AuthType2["gamePayData"] = "gamePayData";
  AuthType2["gameRoleData"] = "gameRoleData";
  return AuthType2;
}(AuthType || {});
var ENV = /* @__PURE__ */ function(ENV2) {
  ENV2["prod"] = "prod";
  ENV2["test"] = "test";
  ENV2["dev"] = "dev";
  return ENV2;
}(ENV || {});
var IegAuthVisibilityType = /* @__PURE__ */ function(IegAuthVisibilityType2) {
  IegAuthVisibilityType2[IegAuthVisibilityType2["IEG_AUTH_CLOSE"] = 0] = "IEG_AUTH_CLOSE";
  IegAuthVisibilityType2[IegAuthVisibilityType2["IEG_AUTH_SELF"] = 1] = "IEG_AUTH_SELF";
  IegAuthVisibilityType2[IegAuthVisibilityType2["IEG_AUTH_ALL"] = 2] = "IEG_AUTH_ALL";
  return IegAuthVisibilityType2;
}(IegAuthVisibilityType || {});
var IegAuthDimensionType = /* @__PURE__ */ function(IegAuthDimensionType2) {
  IegAuthDimensionType2[IegAuthDimensionType2["DIM_DEFULT"] = 0] = "DIM_DEFULT";
  IegAuthDimensionType2[IegAuthDimensionType2["DIM_GAME_DATA"] = 1] = "DIM_GAME_DATA";
  IegAuthDimensionType2[IegAuthDimensionType2["DIM_RELATION_DATA"] = 2] = "DIM_RELATION_DATA";
  return IegAuthDimensionType2;
}(IegAuthDimensionType || {});
function _toPrimitive(input, hint) {
  if (_typeof$1(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof$1(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$1(key) === "symbol" ? key : String(key);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var testCgiHostMap = {
  yyb: "https://iwan-test.yyb.qq.com",
  weishi: "https://iwan-test.weishi.qq.com",
  sports: "https://iwan-test.sports.qq.com",
  video: "https://apptest.iwan.qq.com",
  pc: "https://tpbaccess.video.qq.com"
};
var formalCgiHostMap = {
  yyb: "https://iwan.yyb.qq.com",
  weishi: "https://iwan.weishi.qq.com",
  sports: "https://iwan.sports.qq.com",
  video: "https://iwan.qq.com",
  pc: "https://pbaccess.video.qq.com"
};
var localMap = {
  yyb: "yyb.qq.com",
  weishi: "weishi.qq.com",
  sports: "sports.qq.com",
  video: "iwan.qq.com",
  pc: "video.qq.com"
};
var testPcAuthPageUrl = "https://ovact.iwan.qq.com/iwan/pc/apply-test/index.html";
var formalPcAuthPageUrl = "https://ovact.iwan.qq.com/iwan/pc/apply/index.html";
var trpc = "/trpc.iwan.usr_info_auth_server.UsrInfoAuthServant";
var action = "/ReadUsrAuthInfoWithAppID";
var trpcV2 = "/trpc.iwan.usr_info_auth_server.UsrInfoAuthServantV2";
var actionV2 = "/ReadUsrAuthInfoWithAppID";
var currentEnv = "prod";
var domain = {
  host: "",
  path: "",
  params: ""
};
function getPlat() {
  var matchPlatNames = Object.keys(localMap).filter(function(platName) {
    return window.location.host.includes(localMap[platName]);
  });
  if (matchPlatNames.length > 0) {
    return matchPlatNames[0];
  }
  return "video";
}
function setEnv(env) {
  currentEnv = env;
}
function isDev() {
  return currentEnv === "test" || currentEnv === "dev";
}
function setDomain(currentDomain) {
  Object.assign(domain, currentDomain);
}
function isCustomDomain() {
  return domain.host !== "";
}
function getOrigin() {
  var currentActPlat = getPlat();
  var formalCgiHost = formalCgiHostMap[currentActPlat];
  if (formalCgiHost === "") {
    formalCgiHost = window.location.origin;
  }
  if (isDev()) {
    return testCgiHostMap[currentActPlat];
  }
  return formalCgiHost;
}
function getPcAuthPageUrl() {
  return isDev() ? testPcAuthPageUrl : formalPcAuthPageUrl;
}
function getUserAuthInfoURL() {
  if (isCustomDomain()) {
    return domain.host + domain.path;
  }
  return "".concat(getOrigin() + trpc + action);
}
function getUserAuthInfoURLV2() {
  if (isCustomDomain()) {
    return domain.host + domain.path;
  }
  return "".concat(getOrigin() + trpcV2 + actionV2);
}
var to = function to2(promise) {
  return promise.then(function(data) {
    return [null, data];
  })["catch"](function(err) {
    return [err];
  });
};
var localAuthInfoMap = {};
function getUserAuthInfo(_x) {
  return _getUserAuthInfo.apply(this, arguments);
}
function _getUserAuthInfo() {
  _getUserAuthInfo = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee(appList) {
    var reqAppList, _yield$to, _yield$to2, err, userAuthInfoRes;
    return regenerator.wrap(function _callee$(_context) {
      while (1)
        switch (_context.prev = _context.next) {
          case 0:
            reqAppList = getReqApplist(appList);
            if (!(reqAppList.length === 0)) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return", filterUserAuthInfoByAppList(appList));
          case 3:
            _context.next = 5;
            return to(axios.post(getUserAuthInfoURL(), {
              srcAppList: reqAppList
            }, {
              withCredentials: true
            }));
          case 5:
            _yield$to = _context.sent;
            _yield$to2 = _slicedToArray(_yield$to, 2);
            err = _yield$to2[0];
            userAuthInfoRes = _yield$to2[1];
            if (!err) {
              _context.next = 11;
              break;
            }
            throw err;
          case 11:
            if (!(userAuthInfoRes.data.code !== 0)) {
              _context.next = 13;
              break;
            }
            throw userAuthInfoRes.data;
          case 13:
            Object.assign(localAuthInfoMap, userAuthInfoRes.data.auth_info_map);
            return _context.abrupt("return", filterUserAuthInfoByAppList(appList));
          case 15:
          case "end":
            return _context.stop();
        }
    }, _callee);
  }));
  return _getUserAuthInfo.apply(this, arguments);
}
function getUserAuthInfoV2(_x2, _x3) {
  return _getUserAuthInfoV.apply(this, arguments);
}
function _getUserAuthInfoV() {
  _getUserAuthInfoV = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee2(appId, authAppType) {
    var reqAppList, _yield$to3, _yield$to4, err, userAuthInfoRes;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1)
        switch (_context2.prev = _context2.next) {
          case 0:
            reqAppList = getReqApplist([{
              appId,
              authAppType
            }]);
            if (!(reqAppList.length === 0)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return", filterUserAuthInfoByAppList([{
              appId,
              authAppType
            }]));
          case 3:
            _context2.next = 5;
            return to(axios.post(getUserAuthInfoURLV2(), {
              src_app: {
                app_id: appId,
                auth_app_type: authAppType
              }
            }, {
              withCredentials: true
            }));
          case 5:
            _yield$to3 = _context2.sent;
            _yield$to4 = _slicedToArray(_yield$to3, 2);
            err = _yield$to4[0];
            userAuthInfoRes = _yield$to4[1];
            if (!err) {
              _context2.next = 11;
              break;
            }
            throw err;
          case 11:
            if (!(userAuthInfoRes.data.code !== 0)) {
              _context2.next = 13;
              break;
            }
            throw userAuthInfoRes.data;
          case 13:
            Object.assign(localAuthInfoMap, _defineProperty({}, appId, userAuthInfoRes.data.auth_dimension_map));
            return _context2.abrupt("return", filterUserAuthInfoByAppList([{
              appId,
              authAppType
            }]));
          case 15:
          case "end":
            return _context2.stop();
        }
    }, _callee2);
  }));
  return _getUserAuthInfoV.apply(this, arguments);
}
function filterUserAuthInfoByAppList(appList) {
  var currentAuthInfoMap = {};
  appList.forEach(function(appInfo) {
    currentAuthInfoMap[appInfo.appId] = localAuthInfoMap[appInfo.appId];
  });
  return currentAuthInfoMap;
}
function getReqApplist(appList) {
  if (!isExistLoaclAuthInfoMap()) {
    return appList;
  }
  var newApplist = [];
  appList.forEach(function(appInfo) {
    if (!localAuthInfoMap[appInfo.appId]) {
      newApplist.push(appInfo);
    }
  });
  return newApplist;
}
function clearLocalAuthInfoMap() {
  localAuthInfoMap = {};
}
function isExistLoaclAuthInfoMap() {
  return localAuthInfoMap && Object.keys(localAuthInfoMap).length !== 0;
}
var urlToJson = function urlToJson2() {
  var url = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.location.href;
  var urlObject = {};
  var index = url.indexOf("?");
  if (index === -1) {
    return urlObject;
  }
  var urlString = url.substring(index + 1);
  var urlArray = urlString.split("&");
  for (var i = 0, len = urlArray.length; i < len; i++) {
    var urlItem = urlArray[i];
    var item = urlItem.split("=");
    var _item = _slicedToArray(item, 2), key = _item[0], value = _item[1];
    urlObject[key] = value;
  }
  return urlObject;
};
function isMobile() {
  var _urlToJson = urlToJson(), _urlToJson$iwanGameAu = _urlToJson.iwanGameAuthEnv, iwanGameAuthEnv = _urlToJson$iwanGameAu === void 0 ? "" : _urlToJson$iwanGameAu;
  if (iwanGameAuthEnv) {
    return iwanGameAuthEnv !== "pc";
  }
  if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
    return true;
  }
  return false;
}
function isGrantOneAppAuth(_x, _x2) {
  return _isGrantOneAppAuth.apply(this, arguments);
}
function _isGrantOneAppAuth() {
  _isGrantOneAppAuth = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee(app, authTypeList) {
    return regenerator.wrap(function _callee$(_context) {
      while (1)
        switch (_context.prev = _context.next) {
          case 0:
            console.log(authTypeList);
            _context.next = 3;
            return isGrantOneAppAuthV2(app.appId, app.authAppType);
          case 3:
            return _context.abrupt("return", _context.sent);
          case 4:
          case "end":
            return _context.stop();
        }
    }, _callee);
  }));
  return _isGrantOneAppAuth.apply(this, arguments);
}
function isGrantOneAppAuthV2(_x3) {
  return _isGrantOneAppAuthV.apply(this, arguments);
}
function _isGrantOneAppAuthV() {
  _isGrantOneAppAuthV = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee2(appId) {
    var authAppType, _yield$to, _yield$to2, err, authDimMap, _args2 = arguments;
    return regenerator.wrap(function _callee2$(_context2) {
      while (1)
        switch (_context2.prev = _context2.next) {
          case 0:
            authAppType = _args2.length > 1 && _args2[1] !== void 0 ? _args2[1] : AppType.game;
            _context2.next = 3;
            return to(getUserAuthInfoV2(appId, authAppType));
          case 3:
            _yield$to = _context2.sent;
            _yield$to2 = _slicedToArray(_yield$to, 2);
            err = _yield$to2[0];
            authDimMap = _yield$to2[1];
            if (!err) {
              _context2.next = 9;
              break;
            }
            throw err;
          case 9:
            return _context2.abrupt("return", isAuthForAppV2(authDimMap[appId]));
          case 10:
          case "end":
            return _context2.stop();
        }
    }, _callee2);
  }));
  return _isGrantOneAppAuthV.apply(this, arguments);
}
function isAuthForAppV2() {
  var authDimMap = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return [IegAuthVisibilityType.IEG_AUTH_ALL, IegAuthVisibilityType.IEG_AUTH_SELF].includes(authDimMap[IegAuthDimensionType.DIM_GAME_DATA]);
}
function isGrantAppsAuth(_x4, _x5) {
  return _isGrantAppsAuth.apply(this, arguments);
}
function _isGrantAppsAuth() {
  _isGrantAppsAuth = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee3(appList, authTypeList) {
    var _yield$to3, _yield$to4, err, authInfoMap;
    return regenerator.wrap(function _callee3$(_context3) {
      while (1)
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return to(getUserAuthInfo(appList));
          case 2:
            _yield$to3 = _context3.sent;
            _yield$to4 = _slicedToArray(_yield$to3, 2);
            err = _yield$to4[0];
            authInfoMap = _yield$to4[1];
            if (!err) {
              _context3.next = 8;
              break;
            }
            throw err;
          case 8:
            return _context3.abrupt("return", isAuthForApp(authInfoMap, authTypeList));
          case 9:
          case "end":
            return _context3.stop();
        }
    }, _callee3);
  }));
  return _isGrantAppsAuth.apply(this, arguments);
}
function isAuthForApp(authInfoMap, authTypeList) {
  return Object.keys(authInfoMap).every(function(appId) {
    return isAuthByAuthType(authTypeList, authInfoMap[appId].authDimensionMap);
  });
}
function isAuthByAuthType(authTypeList, authDimensionMap) {
  return authTypeList.every(function(authTypeName) {
    return authDimensionMap[authTypeName];
  });
}
function getGameAuthPageUrl(gameId, redirectURI) {
  var url = isMobile() ? "".concat(getOrigin(), "/auth/apply") : getPcAuthPageUrl();
  if (gameId) {
    url = "".concat(url, "?game_id=").concat(gameId);
    if (redirectURI && redirectURI !== "") {
      url = "".concat(url, "&r_uri=").concat(encodeURIComponent(redirectURI));
    }
  } else {
    if (redirectURI && redirectURI !== "") {
      url = "".concat(url, "?r_uri=").concat(encodeURIComponent(redirectURI));
    }
  }
  return url;
}
function openGameAuthPage(_x6) {
  return _openGameAuthPage.apply(this, arguments);
}
function _openGameAuthPage() {
  _openGameAuthPage = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee4(openPageParams) {
    var url;
    return regenerator.wrap(function _callee4$(_context4) {
      while (1)
        switch (_context4.prev = _context4.next) {
          case 0:
            url = getGameAuthPageUrl(openPageParams === null || openPageParams === void 0 ? void 0 : openPageParams.gameId, openPageParams === null || openPageParams === void 0 ? void 0 : openPageParams.redirectURI);
            openPage(url, openPageParams === null || openPageParams === void 0 ? void 0 : openPageParams.openUrlCallback);
          case 2:
          case "end":
            return _context4.stop();
        }
    }, _callee4);
  }));
  return _openGameAuthPage.apply(this, arguments);
}
function openManagePage(_x7) {
  return _openManagePage.apply(this, arguments);
}
function _openManagePage() {
  _openManagePage = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee5(openUrlCallback) {
    return regenerator.wrap(function _callee5$(_context5) {
      while (1)
        switch (_context5.prev = _context5.next) {
          case 0:
            openPage("".concat(getOrigin(), "/auth/manage"), openUrlCallback);
          case 1:
          case "end":
            return _context5.stop();
        }
    }, _callee5);
  }));
  return _openManagePage.apply(this, arguments);
}
function openPage(_x8, _x9) {
  return _openPage.apply(this, arguments);
}
function _openPage() {
  _openPage = _asyncToGenerator(/* @__PURE__ */ regenerator.mark(function _callee6(url, openUrlCallback) {
    var _yield$to5, _yield$to6, err, openUrl;
    return regenerator.wrap(function _callee6$(_context6) {
      while (1)
        switch (_context6.prev = _context6.next) {
          case 0:
            clearLocalAuthInfoMap();
            if (!openUrlCallback) {
              _context6.next = 5;
              break;
            }
            openUrlCallback(url);
            _context6.next = 12;
            break;
          case 5:
            _context6.next = 7;
            return to(openPage$1(url));
          case 7:
            _yield$to5 = _context6.sent;
            _yield$to6 = _slicedToArray(_yield$to5, 2);
            err = _yield$to6[0];
            openUrl = _yield$to6[1];
            if (err || (openUrl === null || openUrl === void 0 ? void 0 : openUrl.errCode) !== 0) {
              window.location.href = url;
            }
          case 12:
          case "end":
            return _context6.stop();
        }
    }, _callee6);
  }));
  return _openPage.apply(this, arguments);
}
export { AppType, AuthType, ENV, clearLocalAuthInfoMap, getGameAuthPageUrl, isGrantAppsAuth, isGrantOneAppAuth, isGrantOneAppAuthV2, openGameAuthPage, openManagePage, setDomain, setEnv };
